import React from "react";

import { Helpers } from "../../config/Helpers"
import {ReactSession} from "react-client-session";
import {toast} from "react-toastify";
import queryString from "query-string";
import {decode as base64_decode, encode as base64_encode} from "base-64";

class BBXPoin extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            sessKodeNasabah: (ReactSession.get("sess_kodenasabah")) ? ReactSession.get("sess_kodenasabah") : '',
            urlParam: queryString.parse(window.location.search),
            username: '',
            password: '',
            securePassword: true
        }
    }

    componentDidMount() {
        if(!this.state.sessUserCode){
            window.location.href = './login?redirectUrl=' + base64_encode(window.location.href);
        }else{
            if(this.state.sessKodeNasabah){
                window.location.href = './account';
            }
        }
    }

    securePassword = () => {
        this.setState({ securePassword: !this.state.securePassword });
    };

    handleSubmit = (e) => {
        e.preventDefault();

        Helpers.getLoginBBX(this.state.username, this.state.password).then(res => {
            if(res.length > 0){
                const r = res[0];

                if(r.alert === 'error'){
                    toast.error(r.message);
                }else{
                    this.setState({
                        username: '',
                        password: ''
                    });

                    ReactSession.set("sess_kodenasabah", r.kode_nasabah);

                    const parUrl = (this.state.urlParam.redirectUrl) ? base64_decode(this.state.urlParam.redirectUrl) : '';
                    window.location.href = parUrl;
                }
            }else{
                toast.error(Helpers.MSG_ERROR_LOGIN);
            }
        })
    };

    render() {
        return (
            <>
                <main className="main pages auth-page-wrap">
                    <div className="auth-wrap">
                        <div className="auth-hero">
                            <div className="auth-hero-icon">
                                <i className="fi-rs-link"></i>
                            </div>
                            <h1 className="auth-hero-title">Hubungkan BBX Poin</h1>
                            <p className="auth-hero-subtitle">Masuk dengan akun BBX untuk menautkan poin &amp; tabunganmu</p>
                        </div>

                        <div className="auth-card">
                            <form method="post" onSubmit={(e) => {this.handleSubmit(e)}}>
                                <div className="auth-input-group mb-15">
                                    <i className="fi-rs-user auth-input-icon"></i>
                                    <input required type="text" value={this.state.username} onChange={e => this.setState({username: e.target.value})}
                                           placeholder="Username atau Email"/>
                                </div>
                                <div className="auth-input-group mb-10">
                                    <i className="fi-rs-lock auth-input-icon"></i>
                                    <input required type={this.state.securePassword ? 'password' : 'text'} value={this.state.password} onChange={e => this.setState({password: e.target.value})}
                                           placeholder="Password"/>
                                    <i className={'fi-rs-' + (this.state.securePassword ? 'eye' : 'eye-crossed') + ' auth-input-icon-right'} onClick={() => {this.securePassword()}}></i>
                                </div>

                                <button type="submit" className="auth-btn-primary" name="login" style={{marginTop: '10px'}}>Submit</button>
                            </form>
                        </div>
                    </div>
                </main>
            </>
        );
    }
}

export default BBXPoin;